import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { Header } from '../components';
import { InfoContainer } from './components';

const ReleaseArtistName = () => {
  const { t } = useTranslation();

  const releaseId = useOutletContext<string>();

  return (
    <>
      <Header
        title={t('distribution:artistName:title')}
        description={t('distribution:artistName:description')}
      />
      <InfoContainer releaseId={releaseId} />
    </>
  );
};

export default ReleaseArtistName;
